<template>
  <div style="height: calc(100dvh - 154px); width: 100dvw;" class="bg-[#fff] font-WixMadeforDisplay"><router-view/></div>
</template>

<script>
export default {
  name: 'App'
}
</script>
